import type { FunctionComponent, ReactNode } from 'react';

import { IconButtonWithTooltip, Icons } from '../../controls/iconButton/IconButtonWithTooltip';
import { L12nText } from '../../text/L12nText';
import { GameWing } from '../gameWing/GameWing';
import { GameWingItem } from '../gameWingItem/GameWingItem';

export interface BalanceWingProps {
  /** Formatted balance value */
  balance: ReactNode;
  /** Callback to call on cashier button press */
  cashierCallback?: () => void;
  /** Formatted bonus balance value */
  bonus: ReactNode;
  /** Formatted net position value */
  net: ReactNode;
}

/**
 * # BalanceWing
 *
 * Component used to display a balance on wider screens. It is a plain component, so it is **not intended to be used as is**, rather in its `BalanceWingConnected` form.
 * */
export const BalanceWing: FunctionComponent<BalanceWingProps> = ({ balance, cashierCallback, bonus, net }) => {
  return (
    <GameWing>
      <GameWingItem
        dataTestId="balance"
        action={
          cashierCallback ? (
            <IconButtonWithTooltip
              icon={Icons.Cashier}
              onClick={cashierCallback}
              tooltipOptions={{ text: 'CASHIER' }}
            />
          ) : null
        }
        label={<L12nText tk="BALANCE" />}
        value={balance}
      />
      {bonus ? <GameWingItem dataTestId="bonus-balance" label={<L12nText tk="BONUS_BALANCE" />} value={bonus} /> : null}
      {net ? <GameWingItem dataTestId="net-position" label={<L12nText tk="NET_POSITION" />} value={net} /> : null}
    </GameWing>
  );
};
